// The bottom drawer's open state, height and tab, kept per browser. Storage may be
// missing, blocked or full; the drawer then just starts closed.

const DRAWER_STORAGE_KEY = "wktviewer.drawer";
const DEFAULTS = { open: false, heightPx: 220, tab: "profile" };
const TABS = ["profile", "lanes"];

/**
 * @param {{getItem(key: string): string|null}|null} storage
 * @returns {{open: boolean, heightPx: number, tab: "profile"|"lanes"}}
 */
export function loadDrawerState(storage) {
  let stored;
  try {
    stored = JSON.parse(storage?.getItem(DRAWER_STORAGE_KEY) ?? "null");
  } catch {
    return { ...DEFAULTS };
  }
  if (!stored || typeof stored !== "object") return { ...DEFAULTS };
  return {
    open: typeof stored.open === "boolean" ? stored.open : DEFAULTS.open,
    heightPx: Number.isFinite(stored.heightPx)
      ? stored.heightPx
      : DEFAULTS.heightPx,
    tab: TABS.includes(stored.tab) ? stored.tab : DEFAULTS.tab,
  };
}

/** @param {{setItem(key: string, value: string): void}|null} storage */
export function saveDrawerState(storage, state) {
  try {
    storage?.setItem(DRAWER_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Not kept; the drawer still works for this page.
  }
}

/** Between 90 px and 40 px short of the map's height. */
export function clampDrawerHeight(px, mapHeightPx) {
  return Math.max(90, Math.min(px, mapHeightPx - 40));
}
